import Vue from 'vue/dist/vue.esm'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

import en from './locales/en.json'

// const messages = {
//     en: en
// }

// async function loadLocale(locale) {
//     const res = await fetch(`/locales/${locale}.json`)
//     return await res.json()
//   }
  
//   const messages = {}
  
//   async function createI18n() {
//     messages['en'] = await loadLocale('en')
  
//     return new VueI18n({
//       locale: 'en',
//       fallbackLocale: 'en',
//       messages
//     })
//   }
  
//   // i18n will be the old name
//   let i18n = null
//   createI18n().then(result => { i18n = result })

// export { i18n }

// import en from '@assets/locales/en.json'

const messages = {
    en: en
}

const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages
})

export default i18n